import React from "react";


export default () => {
    return <div>
        <h1>404,当前页面存在</h1>
    </div>
}